import TextLine from './TextLine';

interface IProps {
  texts: string[] | JSX.Element[] | (string | JSX.Element)[];
  fontSize?: number;
  isSubText?: boolean;
  italic?: boolean;
  bold?: boolean;
  upperCase?: boolean;
  textEllipsis?: boolean;
}

/** @deprecated */
const TextLines = ({
  texts,
  fontSize,
  isSubText,
  bold,
  italic,
  upperCase,
  textEllipsis,
}: IProps) => {
  return (
    <>
      {texts &&
        texts.map((text, index) => (
          <TextLine
            key={index}
            text={text}
            fontSize={fontSize}
            isSubText={isSubText}
            bold={bold}
            italic={italic}
            upperCase={upperCase}
            textEllipsis={textEllipsis}
          />
        ))}
    </>
  );
};

export default TextLines;
